<template>
  <div class="w100m">
    <div class="w100 flexVC" v-if="$store.state.isPc">
      <div class="title">创始人介绍</div>
      <div class="founder-introduce ">
        <div class="item-container flexHBC">
          <el-image
            class="founder-avatar "
            :src="founderImg"
            :fit="cover"></el-image>
          <div class="content marL20">
            <div class="founder-nickname">王潇</div>
            <div class="founder-title">趁早创始人，“五种时间”理论创建人，知名作家</div>
            <div class="founder-subtitle">2001年本科毕业于中国传媒大学，2007年硕士毕业于中国人民大学，2019年获得长江商学院高级工商管理硕士
            </div>
            <div class="founder-subtitle marT40">2001年，任中央电视台《整点新闻》主播</div>
            <div class="founder-subtitle">2002-2004年，就职于美国安可顾问公司战略传播部</div>
            <div class="founder-subtitle">2008年，创业至今，创办正向生活文创品牌“趁早”、女性健康品牌“SHAPE YOUR LIFE”</div>
            <div class="founder-subtitle">2014-2015年，出任《时尚COSMO》主编</div>
            <div class="founder-subtitle">2010-2018年，出版《趁早》《按自己的意愿过一生》《时间看得见》等七本著作；</div>
            <div class="founder-subtitle">2018年，将趁早升级为正向生活学院，以榜样引导、同类陪伴、挑战激励、社群服务、支持使用者知行合一，创建正向生活。 10年间，趁早星球发展成为百万独立女性的精神家园
            </div>
            <div class="founder-subtitle marT40">曾获得诸多奖项，如：中国作家榜金奖作家，安永亚太区成功女企业家，中国传播年度人物。</div>

            <div class="flexHC" style="margin-top: 45px;">
              <div class="share-img " v-for="(item,index) in footerShare">
                <img :src="item.imgUrl" class="share-img-icon marR20" @mouseenter="moreEnter(index)"
                     @mouseleave="moreLeave(index)">
                <img :src="item.code" class="share-code" v-show="item.isShow">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title">出版著作</div>
      <div class="publish-box flexWrap ">
        <div class="publish-item flexVC" v-for="item in publishData">
          <el-image
            class="publish-img "
            :src="item.coverUrl"
            :fit="cover"></el-image>
          <div class="marT32">{{item.title}}</div>
        </div>
        <div class="publish-item-empty" v-for="count in 3"></div>
      </div>
      <div class="title2">个人荣誉</div>
      <div class="about2">
        <div class="clear-fix-time">
          <!--        <div class="hide-box"></div>-->
          <ul class="clear-fix-time">
            <li>
              <div class="flexHRC">
                <div class="h-line"></div>
                <h4 class="fontS24">2016年</h4>
              </div>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                当当2015年度影响力作家奖</p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                中国第十届作家榜金奖，年度企业家</p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                为最年轻获奖企业家作家且为唯一获奖女性企业家</p>
            </li>
            <li>
              <div class="flexH">
                <div class="h-line"></div>
                <h4 class="fontS24">2017年</h4>
              </div>
              <p class="C000A45 marT10 fontS16 " style="display: flex;justify-content: flex-end;">
                第十一届中国作家榜金奖，企业家作家榜榜眼年度企业家作家</p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                创业邦2017年最值得关注的女性创业者TOP30 蒲公英奖2017中国传播年度人物奖 </p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                新浪微博2017十大影响力运动大V，新浪微博2017跨界职场大V</p>
            </li>

            <li>
              <div class="flexHRC">
                <div class="h-line"></div>
                <h4 class="fontS24">2018年</h4>
              </div>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                “母婴届奥斯卡”2018金树奖</p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                第二十届中国作家榜金奖主榜作家</p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                连续三年蝉联中国作家榜金奖</p>
              <p class="C000A45 marT10 fontS16" style="display: flex;justify-content: flex-end;">
                年度媒体影响力达人首届女性知识行业峰会行业贡献奖</p>
            </li>
          </ul>
        </div>
      </div>
      <div style="height: 150px;"></div>
    </div>
    <div class="w100m Bf0f2f5 flexVC" v-if="!$store.state.isPc">
      <div class="title-m">创始人介绍</div>
      <el-image
        class="founder-avatar-m "
        :src="founderImg"
        :fit="cover"></el-image>
      <div class="content-m flexVC">
        <div class="fontS32m fontW4 C000A85 " style="margin-top: 0.44rem;width: 5.74rem;">王潇</div>
        <div class="founder-title-m" style="margin-top: 0.2rem;">趁早创始人，“五种时间”理论创建人，知名作家</div>
        <div class="founder-subtitle-m" style="margin-top: 0.4rem;">2001年本科毕业于中国传媒大学，2007年硕士毕业于中国人民大学，2019年获得长江商学院高级工商管理硕士
        </div>
        <div class="founder-subtitle-m "style="margin-top: 0.4rem;">2001年，任中央电视台《整点新闻》主播 </div>
        <div class="founder-subtitle-m">2002-2004年，就职于美国安可顾问公司战略传播部</div>
        <div class="founder-subtitle-m">2008年，创业至今，创办正向生活文创品牌“趁早”、女性健康品牌“SHAPE YOUR LIFE”</div>
        <div class="founder-subtitle-m">2014-2015年，出任《时尚COSMO》主编</div>
        <div class="founder-subtitle-m">2010-2018年，出版《趁早》《按自己的意愿过一生》《时间看得见》等七本著作</div>
        <div class="founder-subtitle-m">2018年，将趁早升级为正向生活学院，以榜样引导、同类陪伴、挑战激励、社群服务、支持使用者知行合一，创建正向生活。10年间，趁早星球发展成为百万独立女性的精神家园</div>
        <div class="founder-subtitle-m "style="margin-top: 0.4rem;">曾获得诸多奖项，如：中国作家榜金奖作家，安永亚太区成功女企业家，中国传播年度人物。</div>
        <div style="height: 0.4rem;"></div>
      </div>
      <div class="title-m">出版著作</div>
      <div class="publish-box-m flexWrap ">
        <div class="publish-item-m flexVC" v-for="(item,index) in publishData" :class="index == 1 || index == 4? 'publish-w2' : 'publish-w1'">
          <el-image
            class="publish-img-m "
            :src="item.coverUrl"
            :fit="cover"></el-image>
          <div class="marT32m">{{item.title}}</div>
        </div>
        <div class="publish-item-empty-m" v-for="count in 3"></div>
      </div>
      <div class="title-m">个人荣誉</div>
      <div class="about2-m">
        <div class="clear-fix-time-m">
          <div class="hide-box-m"></div>
          <ul class="clear-fix-time-m">
            <li>
              <div class="flexHRC">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2016年</h4>
              </div>
              <div class="flexHRC">
                <div class="flexV">
                  <p class="C000A45 marT10m fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    当当2015年度影响力作家奖</p>
                  <p class="C000A45 marT10m fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    中国第十届作家榜金奖，年度企业家</p>
                  <p class="C000A45 marT10m fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    为最年轻获奖企业家作家且为唯一获奖女性企业家</p>
                </div>
              </div>
            </li>
            <li>
              <div class="flexH">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2017年</h4>
              </div>
              <p class="C000A45 marT10m fontS24m fontW3">
                第十一届中国作家榜金奖，企业家作家榜榜眼年度企业家作家</p>
              <p class="C000A45 marT10m fontS24m fontW3">
                创业邦2017年最值得关注的女性创业者TOP30 蒲公英奖2017中国传播年度人物奖 </p>
              <p class="C000A45 marT10m fontS24m fontW3">
                新浪微博2017十大影响力运动大V，新浪微博2017跨界职场大V</p>
            </li>

            <li>
              <div class="flexHRC">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2018年</h4>
              </div>
              <div class="flexHRC">
                <div class="flexV">
                  <p class="C000A45 marT10 fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    “母婴届奥斯卡”2018金树奖</p>
                  <p class="C000A45 marT10 fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    第二十届中国作家榜金奖主榜作家</p>
                  <p class="C000A45 marT10 fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    连续三年蝉联中国作家榜金奖</p>
                  <p class="C000A45 marT10 fontS24m fontW3" style="display: flex;justify-content: flex-end;">
                    年度媒体影响力达人首届女性知识行业峰会行业贡献奖</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div style="height: 1.50rem;"></div>
    </div>
    <shape-footer></shape-footer>
  </div>
</template>

<script>
  import shapeFooter from '@/components/ShapeFooter'
  import {publishData} from '@/utils/staticData'

  export default {
    name: "Founder",
    data() {
      return {
        content: '趁早读书会是由创始人王潇于2014年4月23日世界读书日发起，全球各城市自发申请组建的“趁早”线下交流平台，旨在帮助大家遇见彼此，共同学习与见证，分享提升，做更多有意义的事。',
        isShow: true,
        cover: 'cover',
        publishData: [],
        founderImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_founder.png',
        footerShare: [{
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_weibo.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/cion_bottom_webo_code.png',
          isShow: false,
        }, {
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_weixin.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/cion_bottom_weixin_code.jpg',
          isShow: false,
        }, {
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_douyin.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/cion_bottom_douyin_code.jpg',
          isShow: false,
        }, {
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_xiaohongshu.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_code_xiaohongshu.jpg',
          isShow: false,
        },],
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      window.scrollTo(0, 0);
      this.$store.commit('edit', 1)
      this.publishData = publishData
    },

    methods: {
      moreEnter(index) {
        this.footerShare[index].isShow = true
      },
      moreLeave(index) {
        this.footerShare[index].isShow = false
      },
    }

  }
</script>

<style scoped>

  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 160px;
    margin-bottom: 80px;
  }

  .title2 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    /*margin-top: 100px;*/
  }

  .item-container {
    width: calc(100% - 7.71vw - 8.06vw);
  }

  .content {
    width: 600px;
  }

  .founder-introduce {
    width: 100%;
    height: 600px;
    background: rgba(0, 0, 0, 0.02);
  }

  .founder-avatar {
    width: 600px;
    height: 600px;
    margin-left: 7.71vw;
  }

  .founder-nickname {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }

  .founder-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .founder-subtitle {
    font-size: 16px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
  }

  .share-img {
    position: relative;
  }

  .share-img-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .share-code {
    width: 120px;
    height: 120px;
    position: absolute;
    top: -140px;
    left: -60px;
  }

  .publish-box {
    width: 1200px;
    padding-right: 105px;
  }

  .publish-item-empty {
    width: 270px;
    height: 2px;
    margin-left: 105px;
    margin-bottom: 70px;
  }

  .publish-item {
    width: 270px;
    height: 420px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-left: 105px;
    margin-bottom: 70px;
  }

  .publish-img {
    width: 250px;
    height: 349px;
  }


  .h-line {
    width: 40px;
    height: 1px;
    background: #000000;
    margin-left: 32px;
    margin-right: 32px;
    margin-top: 24px;
  }


  .fontS32 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS24 {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS16 {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .C000A85 {
    color: rgba(0, 0, 0, 0.85);
  }

  .C000A25 {
    color: rgba(0, 0, 0, 0.15);
  }

  .C000A45 {
    color: rgba(0, 0, 0, 0.45);
  }

  .fontW6 {
    font-weight: 600;
  }

  .fontW3 {
    font-weight: 300;
  }

  /*  *****************************/
  .hide-box {
    width: 40px;
    height: 40px;
    background: #ffffff;
    position: absolute;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    z-index: 200;
  }

  .clear-fix-time {
    width: 1200px;
    display: list-item;
    zoom: 1;
    position: relative;
  }

  .clear-fix-time:after {
    content: '\20';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0
  }

  .about2 {
    /*padding-bottom: 80px*/
  }

  .about2 .tit {
    text-align: center
  }

  .about2 ul {
    background: url(../../assets/images/icon_time_line.png) repeat-y center
  }

  .about2 .tit h6 {
    color: rgba(0, 0, 0, 0.45);
  }

  .about2 .tit h5 {
    color: #333;
    margin: 15px 0 45px;
  }

  .about2 li:before {
    background: #d70050;
    border: 8px solid #F0F0F0;
    border-radius: 50%;
    right: -24px;
    top: 12px;
    left: auto;
    content: "";
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    z-index: 200;
  }

  .about2 li h4:hover {
    color: #f8f8f8;
    transition: all 1s;
    transform: translateY(-15px)
  }

  .about2 li h4 {
    position: relative;
    display: block;
    text-decoration: none;
    font-family: lato;
    color: #ecf0f1;
    text-transform: uppercase;
    padding: 4px 0;
    transition: .5s
  }

  .about2 li h4::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 1px;
    top: 100%;
    left: 0;
    background: #d70050;
    transition: transform .5s;
    transform: scaleX(0);
    transform-origin: left;
  }

  .about2 li h4:hover {
    color: #95a5a6
  }

  .about2 li h4:hover::after {
    transform: scaleX(1);
    transform-origin: right;
  }

  .about2 li:nth-child(2n):before {
    /*background: url(../../assets/images/icon_time_point.png) no-repeat center center;*/
    background: #d70050;
    border: 8px solid #F0F0F0;
    border-radius: 50%;
    left: -24px;
    top: 12px;
    content: "";
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    z-index: 200;
  }

  .about2 li h4 {
    color: #333;
    transition: all 1s
  }

  .about2 li:nth-child(2n + 1) p {
    color: rgba(0, 0, 0, 0.45);
    margin-top: 10px;
    display: -webkit-box;
    margin-right: 105px;
    font-weight: 300;
    font-family: PingFangSC-Light, PingFang SC;
  }

  .about2 li:nth-child(2n) p {
    width: 384px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 10px;
    display: -webkit-box;
    margin-left: 105px;
    font-weight: 300;
    font-family: PingFangSC-Light, PingFang SC;
  }

  .future {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin-top: 17px
  }

  .about2 li:nth-child(1) {
    /*margin-top: -15px;*/
  }

  .about2 li {
    /*float: left;*/
    width: 49%;
    text-align: right;
    position: relative;
    margin-top: 100px
  }

  .about2 li:nth-child(2n) {
    /*float: right;*/
    margin-left: 51%;
    text-align: left;
    margin-top: 90px
  }

  .flexHRC {
    display: flex;
    flex-direction: row-reverse;
  }

  /*  ******************************/


  /* ************************mobile*************************** */

  .title-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 1.2rem;
    margin-bottom: 0.5rem;
  }

  .founder-avatar-m{
    width: 6.54rem;
    height: 6.54rem;
  }

  .content-m {
    width: 6.54rem;
    /*background: #f00;*/
    background: rgba(0, 0, 0, 0.02);
  }


  .founder-title-m {
    width: 5.74rem;
    font-size: 0.22rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.45);
    line-height: 0.36rem;
  }

  .founder-subtitle-m {
    width: 5.74rem;
    font-size: 0.22rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    line-height: 0.36rem;
  }

  .publish-box-m {
    /*width: 6.70rem;*/
  }

  .publish-item-empty-m {
    width: 2.50rem;
    height: 2px;
  }

  .publish-w1{
    width: 2.00rem;
  }

  .publish-w2{
    width: 3.0rem;
  }

  .publish-item-m {
    height: 3.15rem;
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 0.7rem;
    /*margin-left: 105px;*/
    /*margin-bottom: 70px;*/
  }

  .publish-img-m {
    width: 1.75rem;
    height: 2.62rem;
    box-shadow: 5px 5px 5px #888888;
  }



  .fontS32m {
    font-size: 0.32rem;
  }

  .fontS24m {
    font-size: 0.24rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS28m {
    font-size: 0.28rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .marT32m{
    margin-top: 0.32rem;
  }

  .fontS32m {
    font-size: 0.32rem;
  }

  .h-line-m {
    width: 0.32rem;
    height: 1px;
    background: #000000;
    margin-left: 0.18rem;
    margin-right: 0.18rem;
    margin-top: 0.24rem;
  }

  .fontS24m {
    font-size: 0.24rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .marT10m{
    margin-top: 0.1rem;
  }

  /*  ********************** f0f2f5 *******/
  .hide-box-m {
    width: 0.3rem;
    height: 0.3rem;
    background: #f0f2f5;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 200;
  }

  .clear-fix-time-m {
    width: 100%;
    display: list-item;
    zoom: 1;
    position: relative;
  }

  .clear-fix-time-m:after {
    content: '\20';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0
  }

  .about2-m {
    /*padding-bottom: 80px*/
    width: 100%;
  }

  .about2-m .tit {
    text-align: center
  }

  .about2-m ul {
    background: url(../../assets/images/icon_time_line.png) repeat-y center
    /*background: rgba(0,0,0,.15);*/
  }

  .about2-m .tit h6 {
    color: rgba(0, 0, 0, 0.45);
  }

  .about2-m .tit h5 {
    color: #333;
    margin: 0.15rem 0 0.45rem;
  }

  .about2-m li:before {
    background: #d70050;
    border: 0.1rem solid #F0F0F0;
    border-radius: 50%;
    right: -0.24rem;
    top: 0.10rem;
    left: auto;
    content: "";
    display: block;
    position: absolute;
    width: 0.12rem;
    height: 0.12rem;
    z-index: 200;
  }

  .about2-m li h4:hover {
    color: #f8f8f8;
    transition: all 1s;
    transform: translateY(-0.15px)
  }

  .about2-m li h4 {
    position: relative;
    display: block;
    text-decoration: none;
    font-family: lato;
    color: #ecf0f1;
    text-transform: uppercase;
    padding: 0.04rem 0;
    transition: .5s
  }

  .about2-m li h4::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 0.01rem;
    top: 100%;
    left: 0;
    background: #d70050;
    transition: transform .5s;
    transform: scaleX(0);
    transform-origin: left;
  }

  .about2-m li h4:hover {
    color: #95a5a6
  }

  .about2-m li h4:hover::after {
    transform: scaleX(1);
    transform-origin: right;
  }

  .about2-m li:nth-child(2n):before {
    /*background: url(../../assets/images/icon_time_point.png) no-repeat center center;*/
    background: #d70050;
    border: 0.08rem solid #F0F0F0;
    border-radius: 50%;
    left: -0.24rem;
    top: 0.12rem;
    content: "";
    display: block;
    position: absolute;
    width: 0.12rem;
    height: 0.12rem;
    z-index: 200;
  }

  .about2-m li h4 {
    color: #333;
    transition: all 1s
  }

  .about2-m li:nth-child(2n + 1) p {
    width: 2.6rem;
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Light, PingFang SC;
    margin-top: 0.10rem;
    display: -webkit-box;
    margin-right: 0.7rem;
    text-align: right;
  }

  .about2-m li:nth-child(2n) p {
    width: 2.6rem;
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Light, PingFang SC;
    margin-top: 0.10rem;
    display: -webkit-box;
    text-align: left;
    margin-left: 0.7rem;
  }

  .future {
    text-align: center;
    color: #999;
    font-size: 0.12rem;
    margin-top: 0.17rem;
  }

  .about2-m li:nth-child(1) {
    /*margin-top: -15px;*/
  }

  .about2-m li {
    /*float: left;*/
    width: 49%;
    text-align: right;
    position: relative;
    margin-top: 0.01rem;
  }

  .about2-m li:nth-child(2n) {
    /*float: right;*/
    margin-left: 51%;
    text-align: left;
    margin-top: 0.90rem;
  }

  /*  ******************************/

  /*  *****************************************************/
</style>



// WEBPACK FOOTER //
// src/page/about/Founder.vue